import { useSankeyFormContext } from 'contexts/sankeyFormContext';

import { useSankeyRenderContext } from '../../contexts/sankeyRenderContext';
import { measureText } from '../../diagram/labelPaddings';
import { ep } from '../../diagram/numbers';
import { getSankeyTitle } from '../../diagram/title';
import { useSankeyTitleInteraction } from '../SankeyInteractionProvider/utils';
import TitleEditPopover from './popovers/TitleEditPopover';

const SankeyTitle: React.FC = () => {
  const { form } = useSankeyFormContext();
  const { cfg, graph } = useSankeyRenderContext();
  const { isHighlighted, isFaded, handleMouseOver, handleMouseOut } =
    useSankeyTitleInteraction();

  const title = getSankeyTitle(form.getValues());
  const { width, height } = measureText(cfg, title, cfg.title.font.size);
  const x = (cfg.canvas_width - width) / 2 - graph.leftMargin;
  const y = -12;

  return (
    <g id="sankey_title" transform={`translate(${ep(x)},${ep(y)})`}>
      {isHighlighted && (
        <rect
          x={-width * 0.02}
          y={-height * 0.9}
          width={width * 1.04}
          height={height * 1.2}
          {...cfg.textBackground.highlighted}
        />
      )}
      <TitleEditPopover>
        <text
          cursor="pointer"
          fontWeight={cfg.font.weight.bold}
          fontSize={cfg.title.font.size}
          fill={cfg.title.color}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
          opacity={isFaded ? cfg.fadeOpacity : 1}
        >
          {title}
        </text>
      </TitleEditPopover>
    </g>
  );
};

export default SankeyTitle;
